"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = clearModal;
var _types = require("../types");
/**
 * Close a modal
 *
 * @param type
 * @returns {(function(*): void)|*}
 */
function clearModal(type) {
  return function (dispatch) {
    var action = {
      type: _types.CLEAR_MODAL,
      payload: type
    };
    dispatch(action);
  };
}